import axios from 'axios';
import { normalizeAxiosError } from './api-error.mjs'
// import crypto from './crypto';

const getAuthToken = () => {
    return localStorage.getItem('cloudToken');
};

const setAuthToken = (value) => {
    localStorage.setItem('cloudToken', value);
};

const reAuthToken = () => {
    localStorage.removeItem('cloudToken');
    localStorage.removeItem('cloudName');
};

const request = async (method, url, data, headers, requestConfig = {}) => {
    let requestHeaders = {
        // 'desktop-sign': await crypto.encrypt(),
    };
    const token = getAuthToken();
    if (token) requestHeaders.token = token;
    if (method == 'get') {
        requestHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
    } else {
        requestHeaders['Content-Type'] = 'application/json';
    }
    if (headers) {
        requestHeaders = Object.assign({}, requestHeaders, headers);
    }

    const config = {
        baseURL: process.env.VUE_APP_HTTP_URL,
        method,
        url,
        data,
        headers: requestHeaders,
        timeout: 5000,
        retry: 3,
        retryDelay: 1000,
        ...requestConfig,
    };
    if (typeof data == 'object' && requestHeaders['Content-Type'] == 'application/x-www-form-urlencoded') {
        const params = Object.keys(data).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
        }).join('&').replace(/%20/g, '+');

        if (method == 'post') {
            config.data = params;
        } else {
            config.url += '?' + params;
        }
    }
    return axios(config);
};

const get = (url, data, contentType, getConfig) => {
    return request('get', url, data, contentType, getConfig);
};

const post = (url, data, contentType, postConfig) => {
    return request('post', url, data, contentType, postConfig);
};

const retry = (error) => {
    const config = error.config || (error.response && error.response.config);
    if (!config || !config.retry) return Promise.reject(normalizeAxiosError(error));
    config.__retryCount = config.__retryCount || 1;
    if (config.__retryCount >= config.retry) {
        return Promise.reject(normalizeAxiosError(error));
    }
    config.__retryCount += 1;
    const backoff = new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, config.retryDelay || 1);
    });
    return backoff.then(() => {
        return axios(config);
    });
};

axios.interceptors.response.use((response) => {
    const res = response.data;
    if (res.code === 0) {
        return res.data;
    } else {
        return Promise.reject({
            message: res.msg,
            code: res.code,
            src: response.config.url,
        });
    }
}, (error) => {
    if (error.response) {
        const {
            status,
        } = error.response;
        if ([401, 403].includes(status)) {
            setAuthToken('')
            // location.reload()
            // return Promise.reject({
            //     message: '请重新登录',
            //     code: status,
            //     src: config.url,
            // });
        }
        if (status >= 500) {
            return retry(error);
        }
        return Promise.reject(normalizeAxiosError(error));
    } else {
        return retry(error);
    }
});

const modules = {
    request,
    get,
    post,
    getAuthToken,
    setAuthToken,
    reAuthToken,
};

export default modules;
